import { AxiosResponse } from "axios";
import { StudentDTO } from "../../models/StudentDTO";
import { axiosInstance } from "./axiosInstance";
import { PaginatedResponse } from "../../models/common/PaginatedResponseDTO";

const RESOURCE_URL_V2 = "/admin/campus/";
const RESOURCE_URL_ADMIN_V2 = "/admin/";

export class EmployeeService {

    /* async getEmployeeById(campusId: number, studentId: number): Promise<AxiosResponse<StudentDTO>> {
        const response = await axiosInstance
            .get<StudentDTO>(`${RESOURCE_URL_V2}${campusId}/students/${studentId}/_details`);
        return response;
    }

    getEmployeesByCampusId = async (campusId: number, perPage: number, criteria?: any): Promise<AxiosResponse<PaginatedResponse<StudentDTO>>> => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/_list?perPage=${perPage}`;
        if (criteria && typeof criteria === 'object' && Object.keys(criteria).length > 0) {
            try {
                const criteriaJson = JSON.stringify(criteria);
                uri = `${uri}&criteria=${encodeURIComponent(criteriaJson)}`;
            } catch (error) {
                console.error("Error serializando criteria as JSON:", error);
                throw new Error("Invalid criteria format");
            }
        }
        const response = await axiosInstance.get<PaginatedResponse<StudentDTO>>(uri);
        return response;
    }

    getPaginatedEmployees = async (uri: string): Promise<AxiosResponse<PaginatedResponse<StudentDTO>>> => {
        let response = await axiosInstance.get<PaginatedResponse<StudentDTO>>(uri);
        return response;
    } */

    deleteEmployee = async (campusId: number, studentId: number): Promise<AxiosResponse> => {
        const url = `${RESOURCE_URL_V2}${campusId}/employees/${studentId}`;
        let response = await axiosInstance.delete(url);
        return response;
    }
}